class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    clearTimeout(this.openTimer);
    cancelAnimationFrame(this.openFocusFrame);
    if (this.onOpenTransition) this.removeEventListener('transitionend', this.onOpenTransition);
    this.openIntent = true;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    this.openTimer = setTimeout(() => {
      if (!this.openIntent) return;
      this.classList.add('animate', 'active');
      // Let the visible state paint before moving focus into the dialog.
      this.openFocusFrame = requestAnimationFrame(() => {
        if (!this.openIntent || !this.classList.contains('active')) return;
        this.openFocusFrame = requestAnimationFrame(() => this.onOpenTransition());
      });
    });

    this.onOpenTransition = (event) => {
      if (!this.openIntent || !this.classList.contains('active')) return;
      const inner = this.querySelector('.drawer__inner');
      if (event && event.target !== this && event.target !== inner) return;
      const container = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : inner;
      const focusElement = this.classList.contains('is-empty') ? container?.querySelector('.drawer__close') : inner;
      if (!container || !focusElement) return;
      cancelAnimationFrame(this.openFocusFrame);
      if (getComputedStyle(focusElement).visibility === 'visible') {
        trapFocus(container, focusElement);
        if (container.contains(document.activeElement)) {
          this.removeEventListener('transitionend', this.onOpenTransition);
          return;
        }
      }
      this.openFocusFrame = requestAnimationFrame(() => this.onOpenTransition());
    };
    this.addEventListener('transitionend', this.onOpenTransition);

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.openIntent = false;
    clearTimeout(this.openTimer);
    clearTimeout(this.renderTimer);
    cancelAnimationFrame(this.openFocusFrame);
    if (this.onOpenTransition) this.removeEventListener('transitionend', this.onOpenTransition);
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    renderNovaCartSections(parsedState, this.getSectionsToRender());
    this.classList.toggle('is-empty', window.novaCartState.item_count === 0);

    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return getNovaCartSections();
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return getNovaCartSections();
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
